<template>
  <div>
    <div class="pb-1">
      <span>Formato do arquivo</span>
      <v-icon size="18" class="ml-1" @click="dialog_ativo = true">mdi-help-circle</v-icon>
    </div>

    <v-dialog v-model="dialog_ativo" width="700" content-class="bra-20">
      <v-card>
        <v-card-title class="pt-5 pb-4">
          <span>Formato do arquivo</span>
          <v-spacer />
          <v-btn icon @click="dialog_ativo = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text>
          <BaixarModeloArquivo :url_download_modelo="informativos.url_download_modelo"/>

          <p class="mb-1 font-15 font-weight-medium">O arquivo deve: </p>

          <ul class="ml-n2">
            <li v-for="(linha, indexLinha) in informativos.linhas" :key="indexLinha">
              {{ linha.texto }}
              <span class="font-weight-bold" v-text="linha.texto_final_em_negrito" />
            </li>
          </ul>

          <p class="mb-0 mt-4 font-15 font-weight-medium">Exemplo: </p>

          <table class="w-full mt-1 table-com-bordas">
            <thead>
              <tr>
                <th 
                  class="text-left" 
                  v-for="(linha, indexHeaders) in informativos.headers_tabela_exemplo" 
                  :key="indexHeaders" 
                  v-text="linha" 
                />
              </tr>
            </thead>

            <tbody>
              <tr v-for="(body, indexBody) in informativos.body_tabela_exemplo" :key="indexBody">
                <td 
                  class="text-left" 
                  v-for="(itemBodyHeader, indexBodyHeader) in informativos.headers_tabela_exemplo" 
                  :key="indexBodyHeader"
                  v-text="!['id_produto'].includes(itemBodyHeader) ? body : body.padStart(10, '0')"
                />
              </tr>
            </tbody>
          </table>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import BaixarModeloArquivo from './BaixarModeloArquivo.vue';

export default {
  components: { BaixarModeloArquivo },
  props: {
    informativos: {
      type: Object,
      default: () => ({
        url_download_modelo: 'ping',
        linhas: [
          { 
            texto: "Informe um array de objetos: { text: 'teste', texto_final_em_negrito: 'teste' }", 
            texto_final_em_negrito: "" 
          }
        ],
        headers_tabela_exemplo: ["id_filial", "id_produto"],
        body_tabela_exemplo: ["001", "002"],
      })
    }
  },
  data() {
    return {
      menu: false,
      dialog_ativo: false
    }
  }
}
</script>

<style scoped>
.table-com-bordas {
  border-collapse: collapse;
  border-spacing: 0;
}
.table-com-bordas tr th, tr td {
  border: 1px solid #cbc8c8;
  padding: 0 3px;
}
</style>
